import {SkeletonText} from '@primer/react/experimental'
import {memo} from 'react'

import type {Recap} from '../../api/scribe/types'
import {SanitizedMarkdownViewer} from '../common/sanitized-markdown-viewer'
import styles from './recap-content.module.css'

interface RecapReportProps {
  showLoadingSpinner: boolean
  freshReportData: boolean
  reportHtml: string | undefined
  latestRecap: Recap | null | undefined
}

export const RecapReport = memo(function RecapReport({
  showLoadingSpinner,
  freshReportData,
  reportHtml,
  latestRecap,
}: RecapReportProps) {
  if (!showLoadingSpinner && !(latestRecap?.report && reportHtml)) {
    return null
  }

  return (
    <div className={styles.insightCard}>
      <div className={styles.insightHeader}>
        <h3 className={styles.widgetTitle}>Report</h3>
      </div>
      {showLoadingSpinner && !freshReportData ? (
        <div>
          <div className={styles.skeletonText}>
            <SkeletonText lines={3} aria-label="Generating report" />
          </div>
          <div className={styles.skeletonText}>
            <SkeletonText lines={3} />
          </div>
          <div className={styles.skeletonText}>
            <SkeletonText lines={3} />
          </div>
        </div>
      ) : (
        reportHtml && (
          <div className={styles.reportContent}>
            <SanitizedMarkdownViewer unverifiedHTML={reportHtml} openLinksInNewTab />
          </div>
        )
      )}
    </div>
  )
})

try{ RecapReport.displayName ||= 'RecapReport' } catch {}